import { PreparedCard as BaseCardProps } from 'features/routing-panel/types'
import { createMediaStyles } from 'lib/styled-helpers'
import React, { FC } from 'react'
import styled from 'styled-components'
import { Image } from 'ui/image'
import { Loader } from 'ui/loader'

import { useAppConfig } from '../../../application/configuration'
import { getProjectName } from '../../../lib/get-project-name'
import { useAVNConfig } from '../../../stages/AVN'

export const BaseCard: FC<Omit<BaseCardProps, 'filter'>> = ({
  image,
  price,
  name,
  group,
  quantity,
  children,
  showCarsCount,
  fetchingCarsCount,
  isActive = false,
  carsCount
}) => {
  let { routingPanel } = useAVNConfig()
  const { i18n } = useAppConfig()
  let formatPrice = String(price).replace(/[^0-9]/g, '')

  // склоняет слово автомобиль
  const declensionByNumbers = (number?: string | number | null) => {
    //@ts-ignore
    number = Math.abs(number) % 100
    const num = number % 10
    if (number >= 5 && number < 20) return 'автомобилей'
    if (num > 1 && num < 5) return 'автомобиля'
    if (num === 1) return 'автомобиль'
    return 'автомобиля'
  }

  return (
    <CardContainer>
      <ImageWrapper isActive={isActive}>
        <Image src={image.src} alt={image.alt} fit={image.fit} ratio={image.ratio} sources={image.sources} />
        {children}
      </ImageWrapper>
      {routingPanel?.showCarsName && <Name>{name}</Name>}

      {showCarsCount && getProjectName() === 'generic_v2' && (
        <>
          {fetchingCarsCount ? (
            <Loader />
          ) : (
            <Count>
              {carsCount} {declensionByNumbers(carsCount)} в наличии
            </Count>
          )}
        </>
      )}
      {routingPanel?.showCarsPrice && price && (
        <Price>
          {routingPanel?.i18n?.from} {parseInt(formatPrice).toLocaleString()}{' '}
          {i18n.currencyCode === 'RUB' ? '₽' : i18n.currencyCode}
        </Price>
      )}
    </CardContainer>
  )
}

const CardContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  cursor: pointer;

  ${({ theme }) =>
    createMediaStyles(() => ({
      phone: `align-items: center;
            padding-right:  ${theme.spacing[1]};
            padding-left: ${theme.spacing[1]};`,
      phablet: `align-items: flex-start;
              padding-right: ${theme.spacing[3]};
              padding-left: ${theme.spacing[3]};`
    }))}
  ${() =>
    getProjectName() === 'generic_v2' &&
    `
      padding-left: 10px!important;
      padding-right: 10px!important;
      align-items: flex-start!important;

      @media (max-width: 768px) {
        padding-left: 2px!important;
        padding-right: 2px!important;
      }

      @media (max-width: 1024px) {
        padding-left: 5px!important;
        padding-right: 5px!important;
      }
  `}
`

const ImageWrapper = styled.div<{ isActive: boolean }>`
  position: relative;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing[2]};
  border-radius: '0';
  border: 'none';
  img {
    border-radius: '0';

    ${() =>
      getProjectName() === 'generic_v2' &&
      `
        border-radius: 8px;
      `}
  }
  ${({ isActive }) => isActive && getProjectName() === 'generic_v2' && `background: #1f1f1f;`}

  ${() =>
    getProjectName() === 'generic_v2' &&
    `
      border-radius: 8px;
      border: 1px solid #2c2c2;
  `}
`

const Name = styled.p`
  ${({ theme }) => theme.textStyles.p1};
  font-size: '1.35rem';
  font-weight: '400';
  color: ${({ theme }) =>
    getProjectName() === 'tank' || getProjectName() === 'generic_v2' ? theme.palette.white : theme.palette.black};

  ${({ theme }) =>
    createMediaStyles(() => ({
      phone: `margin-bottom: -${theme.spacing[1]};`,
      tablet: `margin-bottom: ${theme.spacing[0]};`
    }))}
  margin-bottom: ${() => (getProjectName() === 'haval' ? '8px!important' : '0')};

  ${() =>
    getProjectName() === 'generic_v2' &&
    `
      font-weight: 600!important;
      font-size: 16px;
      line-height: 140%;
      margin-top: 0;
  `}
`

const Price = styled.p`
  margin-top: auto;
  margin-bottom: 0;
  ${({ theme }) => theme.textStyles.h5};
  font-size: '1.3rem';
  font-weight: '500';
  color: ${({ theme }) => {
    if (getProjectName() === 'generic_v2') return theme.palette.white
    if (getProjectName() === 'ora' || getProjectName() === 'benda') {
      return theme.palette.black
    }
    return theme.palette.brand.primary
  }};

  ${() =>
    getProjectName() === 'generic_v2' &&
    `
      font-weight: 400;
      font-size: 14px;
      line-height: 140%;
  `}
`
const Count = styled.p`
  margin: 0;
  ${({ theme }) => theme.textStyles.h5};
  font-size: '1.3rem';
  font-weight: '500';
  color: ${({ theme }) => {
    if (getProjectName() === 'generic_v2') return '#828282'
    if (getProjectName() === 'ora' || getProjectName() === 'benda') {
      return theme.palette.black
    }
    return theme.palette.brand.primary
  }};

  ${() =>
    getProjectName() === 'generic_v2' &&
    `
      font-weight: 400;
      font-size: 14px;
      line-height: 140%;
  `}
`
